var exports = {
  "n": "x804f0401--0a6d6b--link",
};

module.exports = exports;
